import 'lazysizes'
import 'lazysizes/plugins/attrchange/ls.attrchange'

window.$ = window.jQuery = require('jquery')

window.Popper = require('popper.js').default

require('bootstrap')